import React, { useEffect, useRef } from "react";
import { PhlebotomyLocation } from "../types";
import PhlebotomyLocationCard, {
  LocationCardAction,
} from "./PhlebotomyLocationCard";

interface PhlebotomyLocationListProps {
  locations: PhlebotomyLocation[];
  selectedLocationIndex: number | null;
  onLocationSelect: (index: number) => void;
  onButtonClick?: (
    type: LocationCardAction,
    location: PhlebotomyLocation,
  ) => void;
  onMobileSchedule?: () => void;
}

const PhlebotomyLocationList: React.FC<PhlebotomyLocationListProps> = ({
  locations,
  selectedLocationIndex,
  onLocationSelect,
  onButtonClick,
  onMobileSchedule,
}) => {
  const cardRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    cardRefs.current = cardRefs.current.slice(0, locations.length);
  }, [locations.length]);

  useEffect(() => {
    if (selectedLocationIndex === null) return;

    const selectedCard = cardRefs.current[selectedLocationIndex];
    const resultsScroller = selectedCard?.closest<HTMLElement>(
      "[data-phlebotomy-results-scroll]",
    );
    if (!selectedCard || !resultsScroller) return;

    const cardTop =
      selectedCard.getBoundingClientRect().top -
      resultsScroller.getBoundingClientRect().top +
      resultsScroller.scrollTop;
    if (typeof resultsScroller.scrollTo === "function") {
      resultsScroller.scrollTo({ top: cardTop, behavior: "smooth" });
      return;
    }
    resultsScroller.scrollTop = cardTop;
  }, [selectedLocationIndex]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      {locations.map((location, index) => (
        <div
          key={`${location.name}-${location.address}`}
          ref={(element) => {
            cardRefs.current[index] = element;
          }}
        >
          <PhlebotomyLocationCard
            location={location}
            index={index}
            isSelected={index === selectedLocationIndex}
            onSelect={onLocationSelect}
            onButtonClick={onButtonClick}
            onMobileSchedule={onMobileSchedule}
          />
        </div>
      ))}
    </div>
  );
};

export default PhlebotomyLocationList;
